/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { InvitingUserDtoModel, InvitingUserDtoModelType } from "./InvitingUserDtoModel"
import { InvitingUserDtoModelSelector } from "./InvitingUserDtoModel.base"
import { OrganizationDtoModel, OrganizationDtoModelType } from "./OrganizationDtoModel"
import { OrganizationDtoModelSelector } from "./OrganizationDtoModel.base"
import { RoleDtoModel, RoleDtoModelType } from "./RoleDtoModel"
import { RoleDtoModelSelector } from "./RoleDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  organization: OrganizationDtoModelType;
  role: RoleDtoModelType;
}

/**
 * UserInviteDtoBase
 * auto generated base class for the model UserInviteDtoModel.
 */
export const UserInviteDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('UserInviteDto')
  .props({
    __typename: types.optional(types.literal("UserInviteDto"), "UserInviteDto"),
    id: types.identifier,
    uuid: types.union(types.undefined, types.string),
    fullname: types.union(types.undefined, types.null, types.string),
    organizationId: types.union(types.undefined, types.number),
    organization: types.union(types.undefined, MSTGQLRef(types.late((): any => OrganizationDtoModel))),
    roleId: types.union(types.undefined, types.number),
    role: types.union(types.undefined, MSTGQLRef(types.late((): any => RoleDtoModel))),
    email: types.union(types.undefined, types.string),
    inviteLink: types.union(types.undefined, types.null, types.string),
    inviteStatusId: types.union(types.undefined, types.number),
    invitedBy: types.union(types.undefined, types.string),
    invitingUser: types.union(types.undefined, types.late((): any => InvitingUserDtoModel)),
    createdOn: types.union(types.undefined, types.string),
    driverProfileId: types.union(types.undefined, types.null, types.number),
    expiresOn: types.union(types.undefined, types.string),
    isDriverInvite: types.union(types.undefined, types.null, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class UserInviteDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get fullname() { return this.__attr(`fullname`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get roleId() { return this.__attr(`roleId`) }
  get email() { return this.__attr(`email`) }
  get inviteLink() { return this.__attr(`inviteLink`) }
  get inviteStatusId() { return this.__attr(`inviteStatusId`) }
  get invitedBy() { return this.__attr(`invitedBy`) }
  get createdOn() { return this.__attr(`createdOn`) }
  get driverProfileId() { return this.__attr(`driverProfileId`) }
  get expiresOn() { return this.__attr(`expiresOn`) }
  get isDriverInvite() { return this.__attr(`isDriverInvite`) }
  organization(builder: string | OrganizationDtoModelSelector | ((selector: OrganizationDtoModelSelector) => OrganizationDtoModelSelector) | undefined) { return this.__child(`organization`, OrganizationDtoModelSelector, builder) }
  role(builder: string | RoleDtoModelSelector | ((selector: RoleDtoModelSelector) => RoleDtoModelSelector) | undefined) { return this.__child(`role`, RoleDtoModelSelector, builder) }
  invitingUser(builder: string | InvitingUserDtoModelSelector | ((selector: InvitingUserDtoModelSelector) => InvitingUserDtoModelSelector) | undefined) { return this.__child(`invitingUser`, InvitingUserDtoModelSelector, builder) }
}
export function selectFromUserInviteDto() {
  return new UserInviteDtoModelSelector()
}

export const userInviteDtoModelPrimitives = selectFromUserInviteDto().uuid.fullname.organizationId.roleId.email.inviteLink.inviteStatusId.invitedBy.createdOn.driverProfileId.expiresOn.isDriverInvite
